import { ParsedNotification, RawNotification } from '../../../types';

const parseDeadline = (rawDeadline?: string): number => {
    const deadline = rawDeadline && Date.parse(String(rawDeadline));

    return deadline && !Number.isNaN(deadline) ? deadline : Date.now();
};

export const parseNotification = (notification: RawNotification = {}): ParsedNotification => ({
    ...notification,
    deadlineAt: parseDeadline(notification.deadlineAt),
    sentAt: Date.now(),
});
